import React, { useState } from 'react'
import Logo from 'widgets/branding/Logo'

export default function Pin () {
  const [pin, setPin] = useState('')

  const addToPin = (digit) => {
    if (pin.length < 4) {
      setPin(pin + digit)
    }
  }

  const numberButtonClasses = 'text-lg w-full inline-flex justify-center items-center px-3 py-2 border border-gray-300 leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-primary-300 focus:shadow-outline-primary active:bg-primary-800 transition ease-in-out duration-150'

  return (
    <div>
      <input name='pin' type='hidden' value={pin} />
      <div className='py-2 border -mx-1 mb-2'>
        <div className='flex w-full h-16 px-6'>
          {pin.split('').map((digit) => {
            return (
              <div key={digit} className='w-1/4 inline-flex items-center justify-center'>
                <div className='h-12 w-12'>
                  <Logo />
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <div className='px-2'>
        <div className='flex mb-4 flex-wrap -mx-4'>

          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(digit => {
            return (
              <span key={digit} className='w-1/3 h-12 px-1 inline-flex rounded-md shadow-sm my-1'>
                <button
                  type='button'
                  className={numberButtonClasses}
                  onClick={() => addToPin(digit)}
                >
                  {digit}
                </button>
              </span>
            )
          })}

          <span className='w-1/3 h-12 px-1 inline-flex rounded-md shadow-sm my-1'>
            <button type='button' className='text-lg w-full inline-flex justify-center items-center px-2.5 py-2 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150' onClick={() => setPin('')}>Reset</button>
          </span>

          <span className='w-1/3 h-12 px-1 inline-flex rounded-md shadow-sm my-1'>
            <button type='button' className={numberButtonClasses} onClick={() => addToPin(0)}>
              0
            </button>
          </span>

          <span className='w-1/3 h-12 px-1 inline-flex rounded-md shadow-sm my-1'>
            <button className='text-lg w-full inline-flex justify-center items-center py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150'>Login</button>
          </span>
        </div>
      </div>
    </div>
  )
}
